import actionCenter from "../../resources/ui/pl/actionCenter.json" 
import addMembersToItem from "../../resources/ui/pl/addMembersToItem.json" 
import admin from "../../resources/ui/pl/admin.json" 
import analytics from "../../resources/ui/pl/analytics.json" 
import autosuggest from "../../resources/ui/pl/autosuggest.json" 
import billing from "../../resources/ui/pl/billing.json" 
import calendarSettings from "../../resources/ui/pl/calendarSettings.json" 
import calendarWidget from "../../resources/ui/pl/calendarWidget.json" 
import chat from "../../resources/ui/pl/chat.json" 
import codeInput from "../../resources/ui/pl/codeInput.json" 
import companyTemplate from "../../resources/ui/pl/companyTemplate.json" 
import companyType from "../../resources/ui/pl/companyType.json" 
import confirmCloseDialog from "../../resources/ui/pl/confirmCloseDialog.json" 
import contactType from "../../resources/ui/pl/contactType.json" 
import contactWidget from "../../resources/ui/pl/contactWidget.json" 
import customInputFormEditor from "../../resources/ui/pl/customInputFormEditor.json" 
import dataTypeSelectionTranslate from "../../resources/ui/pl/dataTypeSelectionTranslate.json" 
import dataTypeWidget from "../../resources/ui/pl/dataTypeWidget.json" 
import dataTypes from "../../resources/ui/pl/dataTypes.json" 
import daysToAlertOnUnusedItemTranslate from "../../resources/ui/pl/daysToAlertOnUnusedItemTranslate.json" 
import drawerListItem from "../../resources/ui/pl/drawerListItem.json" 
import drawerListItemSettigs from "../../resources/ui/pl/drawerListItemSettigs.json" 
import drawerListItemTerms from "../../resources/ui/pl/drawerListItemTerms.json" 
import drowerGroupsMenu from "../../resources/ui/pl/drowerGroupsMenu.json" 
import drowerSubscribedMenu from "../../resources/ui/pl/drowerSubscribedMenu.json" 
import editCollection from "../../resources/ui/pl/editCollection.json" 
import exportMenuTranslate from "../../resources/ui/pl/exportMenuTranslate.json" 
import favouritesView from "../../resources/ui/pl/favouritesView.json" 
import feedToolbar from "../../resources/ui/pl/feedToolbar.json" 
import feedWidgets from "../../resources/ui/pl/feedWidgets.json" 
import fieldsSelectionTranslate from "../../resources/ui/pl/fieldsSelectionTranslate.json" 
import filesUploader from "../../resources/ui/pl/filesUploader.json" 
import filterModal from "../../resources/ui/pl/filterModal.json" 
import footerTableCellTranslate from "../../resources/ui/pl/footerTableCellTranslate.json" 
import gantt from "../../resources/ui/pl/gantt.json" 
import groupDrawerTranslate from "../../resources/ui/pl/groupDrawerTranslate.json" 
import groupTable from "../../resources/ui/pl/groupTable.json" 
import groupWidgetTranslate from "../../resources/ui/pl/groupWidgetTranslate.json" 
import headerTableCellTranslate from "../../resources/ui/pl/headerTableCellTranslate.json" 
import i18_newKanban from "../../resources/ui/pl/i18_newKanban.json" 
import inputContactSection from "../../resources/ui/pl/inputContactSection.json" 
import inputFab from "../../resources/ui/pl/inputFab.json" 
import inputLinks from "../../resources/ui/pl/inputLinks.json" 
import inputLocation from "../../resources/ui/pl/inputLocation.json" 
import inputLocationFields from "../../resources/ui/pl/inputLocationFields.json" 
import inputSuggest from "../../resources/ui/pl/inputSuggest.json" 
import inputTypes from "../../resources/ui/pl/inputTypes.json" 
import itemFullViewModal from "../../resources/ui/pl/itemFullViewModal.json" 
import itemPreviewCardHeaderMenu from "../../resources/ui/pl/itemPreviewCardHeaderMenu.json" 
import itemPreviewCardHeaderTranslate from "../../resources/ui/pl/itemPreviewCardHeaderTranslate.json" 
import itemPreviewCommentBarTranslate from "../../resources/ui/pl/itemPreviewCommentBarTranslate.json" 
import kanbanTranslate from "../../resources/ui/pl/kanbanTranslate.json" 
import knowledgeTranslate from "../../resources/ui/pl/knowledgeTranslate.json" 
import labelMenu from "../../resources/ui/pl/labelMenu.json" 
import laneColorsWidget from "../../resources/ui/pl/laneColorsWidget.json" 
import lastActivitiesInGroup from "../../resources/ui/pl/lastActivitiesInGroup.json" 
import library from "../../resources/ui/pl/library.json" 
import listRules from "../../resources/ui/pl/listRules.json" 
import liveActivityWidget from "../../resources/ui/pl/liveActivityWidget.json" 
import locationWidget from "../../resources/ui/pl/locationWidget.json" 
import menuTableToolbarTranslate from "../../resources/ui/pl/menuTableToolbarTranslate.json" 
import moreInputsDrawer from "../../resources/ui/pl/moreInputsDrawer.json" 
import mustReadListModal from "../../resources/ui/pl/mustReadListModal.json" 
import mustReadWidget from "../../resources/ui/pl/mustReadWidget.json" 
import myReportsView from "../../resources/ui/pl/myReportsView.json" 
import newGroupDialog from "../../resources/ui/pl/newGroupDialog.json" 
import noResults from "../../resources/ui/pl/noResults.json" 
import noteEditView from "../../resources/ui/pl/noteEditView.json" 
import notificationSettings from "../../resources/ui/pl/notificationSettings.json" 
import notificationsDrawer from "../../resources/ui/pl/notificationsDrawer.json" 
import notifyMeModal from "../../resources/ui/pl/notifyMeModal.json" 
import orgCharts from "../../resources/ui/pl/orgCharts.json" 
import pollTemplate from "../../resources/ui/pl/pollTemplate.json" 
import postInput from "../../resources/ui/pl/postInput.json" 
import queryViews from "../../resources/ui/pl/queryViews.json" 
import relatedItems from "../../resources/ui/pl/relatedItems.json" 
import relatedModal from "../../resources/ui/pl/relatedModal.json" 
import renderInput from "../../resources/ui/pl/renderInput.json" 
import rowPerPageTranslate from "../../resources/ui/pl/rowPerPageTranslate.json" 
import scoreboard from "../../resources/ui/pl/scoreboard.json" 
import search from "../../resources/ui/pl/search.json" 
import searchFile from "../../resources/ui/pl/searchFile.json" 
import searchMedia from "../../resources/ui/pl/searchMedia.json" 
import searchPage from "../../resources/ui/pl/searchPage.json" 
import searchToolbarTabs from "../../resources/ui/pl/searchToolbarTabs.json" 
import settingsDrawer from "../../resources/ui/pl/settingsDrawer.json" 
import socialData from "../../resources/ui/pl/socialData.json" 
import subheaderToolbar from "../../resources/ui/pl/subheaderToolbar.json" 
import suggestedNews from "../../resources/ui/pl/suggestedNews.json" 
import tagsTemplate from "../../resources/ui/pl/tagsTemplate.json" 
import tagsWidget from "../../resources/ui/pl/tagsWidget.json" 
import taskList from "../../resources/ui/pl/taskList.json" 
import taskListItem from "../../resources/ui/pl/taskListItem.json" 
import taskModal from "../../resources/ui/pl/taskModal.json" 
import timeDateWidget from "../../resources/ui/pl/timeDateWidget.json" 
import upgradeSubscription from "../../resources/ui/pl/upgradeSubscription.json" 
import userEditModal from "../../resources/ui/pl/userEditModal.json" 
import userFollowingWidget from "../../resources/ui/pl/userFollowingWidget.json" 
import userGroupsWidget from "../../resources/ui/pl/userGroupsWidget.json" 
import userOngoing from "../../resources/ui/pl/userOngoing.json" 
import userProfileWidget from "../../resources/ui/pl/userProfileWidget.json" 
import userSettings from "../../resources/ui/pl/userSettings.json" 
import userSettingsDrawer from "../../resources/ui/pl/userSettingsDrawer.json" 
import userTeamWidget from "../../resources/ui/pl/userTeamWidget.json" 
import userWorksWidget from "../../resources/ui/pl/userWorksWidget.json" 
import usersListTranslate from "../../resources/ui/pl/usersListTranslate.json" 
import usersWidget from "../../resources/ui/pl/usersWidget.json" 
import webResults from "../../resources/ui/pl/webResults.json" 
import widgetFilter from "../../resources/ui/pl/widgetFilter.json" 
import widgetLibrary from "../../resources/ui/pl/widgetLibrary.json" 

export const pl = {
	actionCenter, 
	addMembersToItem, 
	admin, 
	analytics, 
	autosuggest, 
	billing, 
	calendarSettings, 
	calendarWidget, 
	chat, 
	codeInput, 
	companyTemplate, 
	companyType, 
	confirmCloseDialog, 
	contactType, 
	contactWidget, 
	customInputFormEditor, 
	dataTypeSelectionTranslate, 
	dataTypeWidget, 
	dataTypes, 
	daysToAlertOnUnusedItemTranslate, 
	drawerListItem, 
	drawerListItemSettigs, 
	drawerListItemTerms, 
	drowerGroupsMenu, 
	drowerSubscribedMenu, 
	editCollection, 
	exportMenuTranslate, 
	favouritesView, 
	feedToolbar, 
	feedWidgets, 
	fieldsSelectionTranslate, 
	filesUploader, 
	filterModal, 
	footerTableCellTranslate, 
	gantt, 
	groupDrawerTranslate, 
	groupTable, 
	groupWidgetTranslate, 
	headerTableCellTranslate, 
	i18_newKanban, 
	inputContactSection, 
	inputFab, 
	inputLinks, 
	inputLocation, 
	inputLocationFields, 
	inputSuggest, 
	inputTypes, 
	itemFullViewModal, 
	itemPreviewCardHeaderMenu, 
	itemPreviewCardHeaderTranslate, 
	itemPreviewCommentBarTranslate, 
	kanbanTranslate, 
	knowledgeTranslate, 
	labelMenu, 
	laneColorsWidget, 
	lastActivitiesInGroup, 
	library, 
	listRules, 
	liveActivityWidget, 
	locationWidget, 
	menuTableToolbarTranslate, 
	moreInputsDrawer, 
	mustReadListModal, 
	mustReadWidget, 
	myReportsView, 
	newGroupDialog, 
	noResults, 
	noteEditView, 
	notificationSettings, 
	notificationsDrawer, 
	notifyMeModal, 
	orgCharts, 
	pollTemplate, 
	postInput, 
	queryViews, 
	relatedItems, 
	relatedModal, 
	renderInput, 
	rowPerPageTranslate, 
	scoreboard, 
	search, 
	searchFile, 
	searchMedia, 
	searchPage, 
	searchToolbarTabs, 
	settingsDrawer, 
	socialData, 
	subheaderToolbar, 
	suggestedNews, 
	tagsTemplate, 
	tagsWidget, 
	taskList, 
	taskListItem, 
	taskModal, 
	timeDateWidget, 
	upgradeSubscription, 
	userEditModal, 
	userFollowingWidget, 
	userGroupsWidget, 
	userOngoing, 
	userProfileWidget, 
	userSettings, 
	userSettingsDrawer, 
	userTeamWidget, 
	userWorksWidget, 
	usersListTranslate, 
	usersWidget, 
	webResults, 
	widgetFilter, 
	widgetLibrary, 
}